import type { Basket, ISimpleBasket } from '../../redux/slices/basket/basketApi'

/**
 * Sohbetten yapılan sepet değişikliğinden sonra (backend `basketChanged`, Faz-30) rozeti ve açık sepet
 * sayfasını eşitler: sepet taze okunur, `syncActiveBasket` ile Redux'a yazılır. `getFreshBasketRedux`
 * BİLEREK kullanılmaz — thunk `basketApiCallStatus`'u 'loading' yapar ve tam sayfa spinner'ı sohbet
 * panelinin (z-index 99999) arkasında açılır (Faz-29 ile aynı gerekçe). Apple vitrin kullanıcısında
 * sepet okunmaz (thunk'ın kuralı). Hata sessizce yutulur: sepet zaten değişti, rozet bir sonraki sayfa
 * yüklemesinde düzelir.
 */
export async function refreshBasketAfterChat(
  fetchBasket: () => Promise<Basket>,
  sync: (basket: ISimpleBasket) => void,
  isApple: boolean
): Promise<boolean> {
  if (isApple) return false
  try {
    const basket = await fetchBasket()
    if (!basket?.ActiveBasket) return false
    sync(basket.ActiveBasket)
    return true
  } catch {
    return false
  }
}
